<!-- eslint-disable vue/no-v-html -->
<template>
  <a
    class="inline-flex p-3 rounded-full group"
    :style="{ backgroundColor: $options.social[platform].color }"
  >
    <p
      class="w-5 h-5 text-white transition transform group-hover:scale-125 [&_path]:fill-current"
      v-html="$options.social[platform].icon.svg"
    />
  </a>
</template>

<script>
import social from "@/assets/social.js";
export default {
  social,
  props: {
    platform: { type: String, default: null },
  },
};
</script>
